/**
* This file was auto-generated by the FrontendConstantsGenerator.
* Do not make direct changes to the file.
*/

export const DistributorTypes = {
  WE_PAY: 'we_pay',
  THEY_PAY: 'they_pay',
  NONE: 'none',
}
